import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import {
  getDemoRajOperatingPar,
  getRajOperatingPar,
} from "../../../Rest_api/RestApi";
import FilterMenu from "../../../components/FilterMenu";
import { RajGenParams } from "../../../models/rajasthan";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { ChartType, ReChartData } from "../../../models/chart_model";
import { SearchBox } from "../../../components/Search";
import { COLOR_CODES } from "../../../common";
import { GnaRuvnlFooter } from "../components";
import Tooltip from "../../../components/tooltip";
import MainPageContainer from "../../../components/MainPageContainer";
import NewFilterContainer from "../../../components/NewFilterContainer ";
import SecondaryHeader from "../Demand/SecondaryHeader";
const PARAMETERS = [
  {
    label: "Total Capacity/Installed(MW)",
    key: "total_capacity_installed_mw",
    unit: "MW",
  },
  {
    label: "Normative Availability(%)",
    key: "normative_availability_percent",
    unit: "%",
  },
  {
    label: "Availability(%)",
    key: "availability_percent",
    unit: "%",
  },
  {
    label: "PLF(%)",
    key: "plf_percent",
    unit: "%",
  },
  {
    label: "Fix Charges as per RERC ORDER/PPA (Rs/kWh)",
    key: "fix_charges_rs_per_kwh",
    unit: "Rs/kWh",
  },
  {
    label: "Variable Charges as per RERC ORDER/PPA (Rs/kWh)",
    key: "variable_charges_rs_per_kwh",
    unit: "Rs/kWh",
  },
  {
    label: "Total Tariff in Rs./kWh",
    key: "total_tariff_rs_per_kwh",
    unit: "Rs/kWh",
  },
  {
    label: "Share of State(%)",
    key: "share_of_state_percent",
    unit: "%",
  },
];

export const OperatingPar = () => {
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState<ReChartData[]>([]);
  const [data, setData] = useState<RajGenParams[]>([]);
  const [selectedParameter, setSelectedParameter] = useState(PARAMETERS[0]);
  const [selectedSecondPar, setSelectedSecondPar] = useState(PARAMETERS[1]);
  const [generator, setGenerator] = useState<string[]>([]);
  const [selectedGenerator, setSelectedGenerator] = useState<string | null>(
    null
  );
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  useEffect(() => {
    _handlefetchData();
  }, []);
  async function _handlefetchData() {
    const res = await getDemoRajOperatingPar();
    setData(res);
    const uniqueGenerator = Array.from(
      new Set(res.map((item) => item.generator))
    );
    setGenerator(uniqueGenerator);
    setSelectedGenerator(uniqueGenerator[0]);
  }

  useEffect(() => {
    let filteredData = data;
    if (selectedGenerator) {
      filteredData = filteredData.filter(
        (item) => item.generator === selectedGenerator
      );
    }
    if (selectedYear) {
      filteredData = filteredData.filter((item) => item.year === selectedYear);
    }
    setChartData(filteredData as any[]);
    setLoading(false);
  }, [data, selectedParameter, selectedGenerator, selectedYear]);
  return (
    <div className="gas-page-container">
      {loading && <Loading />}
      <NewFilterContainer>
        <div className="side-filters-container ">
          <FilterMenu
            title="First Parameters"
            items={PARAMETERS.map((item) => item.label)}
            selectedItems={[selectedParameter.label]}
            onSelect={(item, index) => setSelectedParameter(PARAMETERS[index])}
          />
          <FilterMenu
            title="Second Parameters"
            items={PARAMETERS.map((item) => item.label)}
            selectedItems={[selectedSecondPar.label]}
            onSelect={(item, index) => setSelectedSecondPar(PARAMETERS[index])}
          />
        </div>
      </NewFilterContainer>

      <MainPageContainer>
        <SecondaryHeader showViewMode={false} />
        <div className="gas-chart-container">
          <div className="gas-heading">
            <h2 className="chartHeading">Operating Parameters</h2>
            <SearchBox
              options={generator.map((item) => ({ label: item, value: item }))}
              selectedOptions={
                selectedGenerator
                  ? [{ label: selectedGenerator, value: selectedGenerator }]
                  : []
              }
              onChange={(selected: any) =>
                setSelectedGenerator(selected ? selected.value : null)
              }
              placeholder={"Select Station"}
            />
          </div>
          <ReMixChart
            data={chartData}
            unit={""}
            yAxisLabel={selectedParameter.label}
            xDataKey={"year"}
            barCategoryGap={24}
            xLabel="Year"
            secondYAxisLabel={selectedSecondPar.label}
            legends={[
              {
                dataKey: selectedParameter.key,
                stroke: COLOR_CODES.primary,
                name: selectedParameter.label,
                type: ChartType.Bar,
              },
              {
                dataKey: selectedSecondPar.key,
                stroke: COLOR_CODES.secondary,
                name: selectedSecondPar.label,
                type: ChartType.Bar,
                yAxisId: "right",
              },
            ]}
          />
        </div>
        <div className="gna-footer-container">
          <div className="grid grid-cols-2 justify-between gap-5 ">
            <p className="gna-footer-text text-start col-span-1">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Demo Version
            </strong>
          </div>
        </div>
      </MainPageContainer>
    </div>
  );
};
